import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@/components/ui";
import { useAuth, roleHome } from "@/context/AuthContext";

export function Topbar({ title, subtitle, right }) {
  const nav = useNavigate();
  const { user } = useAuth();
  return (
    <div className="topbar">
      <div className="topbar-brand" data-testid="topbar-home" onClick={() => nav(user ? roleHome(user.role) : "/")}>
        <img src="/homecarematches-logo.png" alt="HomecareMatches" />
        <div>
          <div className="topbar-title">{title || "HomecareMatches"}</div>
          {subtitle ? <div className="topbar-sub">{subtitle}</div> : null}
        </div>
      </div>
      <div className="topbar-actions">{right}</div>
    </div>
  );
}

export function PortalActions({ profilePrefix = "" }) {
  const nav = useNavigate();
  const { logout } = useAuth();
  return (
    <>
      <button className="icon-btn" data-testid={`${profilePrefix}profile-btn`} title="Profile" onClick={() => nav("/profile")}>
        <Icon name="user" size={20} />
      </button>
      <button className="icon-btn" data-testid={`${profilePrefix}logout`} title="Sign out"
        onClick={async () => { await logout(); nav("/"); }}>
        <Icon name="log-out" size={20} />
      </button>
    </>
  );
}

export function SiteFooter() {
  const nav = useNavigate();
  return (
    <footer className="site-footer">
      <div className="inner">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src="/homecarematches-logo.png" alt="" style={{ height: 34 }} />
          <span className="muted" style={{ fontSize: 13 }}>© {new Date().getFullYear()} HomecareMatches · Connecting care. Improving lives.</span>
        </div>
        <div className="footer-links">
          <a data-testid="footer-families" onClick={() => nav("/for-families")}>For Families</a>
          <a data-testid="footer-caregivers" onClick={() => nav("/for-caregivers")}>For Caregivers</a>
          <a data-testid="footer-agencies" onClick={() => nav("/for-agencies")}>For Agencies</a>
          <a data-testid="footer-terms" onClick={() => nav("/terms")}>Terms</a>
          <a data-testid="footer-privacy" onClick={() => nav("/privacy")}>Privacy</a>
          <a data-testid="footer-contact" onClick={() => nav("/contact")}>Contact</a>
        </div>
      </div>
    </footer>
  );
}

/** Guards a route by allowed roles. Redirects to /login if unauthenticated. */
export function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  React.useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login", { replace: true }); return; }
    if (roles && !roles.includes(user.role)) { nav(roleHome(user.role), { replace: true }); }
  }, [user, loading]); // eslint-disable-line
  if (loading || !user) return <div className="center"><div className="spinner" /></div>;
  if (roles && !roles.includes(user.role)) return null;
  return children;
}
